import i18next from 'i18next';
import * as bd from 'react-basic-design';
import { Link } from 'react-router-dom';
import settings from '../../app/settings';
import SvgDarkMode from '../../assets/icons/DarkMode';
import SvgHome from '../../assets/icons/Home';
import { code } from '../../components/basic/code';
import { T } from '../../components/basic/text';
import { useAccount } from '../../app/account-context';
import { UserMenuBar } from './user-menu-bar';

export function AppbarShell() {
    const account = useAccount();

    return (
        <>
            <bd.AppBar className="bg-shell text-shell">
                <bd.Toolbar size="md" style={{ height: 'auto' }}>
                    <div className="appbar-title">
                        <bd.Flex align="center" gap={2}>
                            <Link
                                to={account.isConnected() ? '/home' : '/'}
                                className=" text-decoration-none "
                                style={{ color: '#fea', verticalAlign: 'middle' }}
                            >
                                {!account.isConnected() && (
                                    <SvgHome
                                        style={{ color: '#fea', textShadow: '0 0 10px #ff0' }}
                                        className="m-e-3 edge-start"
                                    />
                                )}
                                <T title={settings.version}>{settings.title}</T>
                            </Link>

                            {code.isDevelopmentEnv() && <></>}
                        </bd.Flex>
                    </div>

                    <UserMenuBar />
                </bd.Toolbar>
            </bd.AppBar>
        </>
    );
}
